import Airtable from 'airtable';

// api keys are confidential
const base = new Airtable({ apiKey: 'patfk3uZOHmmgHpg0.f9439decad8379c1d9d93f69abc53be1f0bfe7f1c56a8edde9c2657491e74b96' }).base(
  'appo9QNCqgrMYau6A'
);

export default base;
